import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-operation-finished-modal',
  templateUrl: './operation-finished-modal.component.html',
  styleUrls: ['./operation-finished-modal.component.scss'],
})
export class OperationFinishedModalComponent implements OnInit {
  successful: boolean = false;

  title: string = 'Operación finalizada';
  content: string = 'La operación ha finalizado';
  submit: Subject<any>;

  constructor(private modalRef: BsModalRef) {
    this.submit = new Subject();
  }

  ngOnInit(): void {
    // Backward compatibility: Handle both old error object format and new message format
    if (typeof this.content === 'object' && this.content !== null) {
      // Old format: entire error object was passed
      this.content = (this.content as any).message ||
                     (this.content as any).error?.error?.message ||
                     'Algo pasó, vuelve a intentarlo';
    }
  }

  close() {
    this.submit.next('closed');
    this.modalRef.hide();
  }
}
